import { ExternalServiceHeaders } from '../api/integrations';

function convertHeadersToArray(
	integrationHeaders: ExternalServiceHeaders,
): { headerName: string; value: string }[] {
	return Object.entries(integrationHeaders).map(([headerName, value]) => ({
		headerName,
		value,
	}));
}

export default convertHeadersToArray;
